import { Col, Row } from "../../components/Grid";
import PropTypes from "prop-types";
import React from "react";
import Tab from "./Tab";
import TabMenu from "./TabMenu";
import injectSheet from "react-jss";
import productsList from "../../content/productsList";
import Image from "../Image";
import Logo from "../../img/EtechLogo.png";

const styles = theme => ({
  topBar: {
    backgroundColor: theme.colours.palette.blue,
    fontWeight: "400",
    maxHeight: "84px",
    transition: "max-height .5s ease"
  },
  logoContainer: {
    paddingLeft: "0.5rem",
    maxHeight: "84px",
    height: "84px",
    marginTop: "2rem",
    marginBottom: "1rem"
  },
  logo: {
    maxHeight: "80%"
  },
  navLink: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
    color: "white",
    textAlign: "center",
    justifyContent: "center"
  },
  productNavLink: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
    color: "white",
    textAlign: "center",
    justifyContent: "center",
    visibility: "hidden",
    transition: "visibility 0 .5s"
  },
  mobileProductsButton: {
    width: "100%",
    color: "white",
    textAlign: "center",
    justifyContent: "center"
  },
  mobileProductsLinks: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#3199c7",
    maxHeight: "0px",
    transition: "max-height .5s ease"
  },
  dropDownItem: {
    color: "white",
    width: "100%",
    display: "block",
    textAlign: "center",
    padding: "25px 0"
  },
  tabRow: {
    height: "100%"
  },
  header: {
    height: "84px",
    "&:hover $topBar": {
      maxHeight: "400px"
    }
  },
  tabRowMobile: {
    display: "none"
  },
  mobileMenuButton: {
    paddingRight: "0.5rem",
    display: "none"
  },
  mobileMenuCheckbox: {
    display: "none",
    "&:checked ~ $topBar": {
      maxHeight: "614px",
      "& $tabRowMobile": {
        visibility: "visible"
      }
    }
  },
  mobileProductsButtonCheckbox: {
    display: "none",
    "&:checked ~ $mobileProductsLinks": {
      maxHeight: "300px",
      "& $productNavLink": {
        visibility: "visible",
        transition: "visibility 0s 0s"
      }
    }
  },
  line: {
    height: "2.4px",
    width: "28px",
    backgroundColor: "white",
    margin: "8.5px"
  },
  "@media (max-width: 823px)": {
    navLink: {
      padding: "1rem 0",
      width: "100%"
    },
    productNavLink: {
      padding: "1rem 0",
      width: "100%"
    },
    mobileProductsButton: {
      padding: "0.35rem 0"
    },
    tabRow: {
      display: "none"
    },
    tabRowMobile: {
      display: "block",
      visibility: "hidden"
    },
    mobileMenuButton: {
      display: "block"
    }
  }
});

const TopBar = ({ classes }) => (
  <div>
    <input
      type="checkbox"
      id="mobileMenuCheckbox"
      className={classes.mobileMenuCheckbox}
      value="on"
    />
    <div className={classes.topBar}>
      <div className={classes.header}>
        <Row middle between>
          <div className={classes.logoContainer}>
            <Image image={Logo} className={classes.logo} />
          </div>
          <div className={classes.tabRow}>
            <Row middle center>
              <Tab
                className={classes.navLink}
                targetLink="/"
                anchorText="Home"
              />
              <TabMenu className={classes.navLink} anchorText="Products">
                <Col>
                  {productsList.map(product => (
                    <Tab
                      key={product.label}
                      className={classes.dropDownItem}
                      targetLink={product.targetLink}
                      anchorText={product.label}
                    />
                  ))}
                </Col>
              </TabMenu>
              <Tab
                className={classes.navLink}
                targetLink="/about"
                anchorText="About"
              />
              <Tab
                className={classes.navLink}
                targetLink="http://blog.electedtechnologies.com/"
                anchorText="Blog"
              />
              <Tab
                className={classes.navLink}
                targetLink="/contact"
                anchorText="Contact"
              />
            </Row>
          </div>
          <label
            className={classes.mobileMenuButton}
            id="mobileMenuButton"
            htmlFor="mobileMenuCheckbox"
          >
            <div className={classes.line} />
            <div className={classes.line} />
            <div className={classes.line} />
          </label>
        </Row>
      </div>
      <div className={classes.tabRowMobile}>
        <Col middle center>
          <input
            type="checkbox"
            id="mobileProductsButtonCheckbox"
            className={classes.mobileProductsButtonCheckbox}
            value="on"
          />
          <Tab className={classes.navLink} targetLink="/" anchorText="Home" />
          <label
            className={classes.mobileProductsButton}
            id="mobileProductsButton"
            htmlFor="mobileProductsButtonCheckbox"
          >
            Products
          </label>
          <div className={classes.mobileProductsLinks}>
            {productsList.map(product => (
              <Tab
                key={product.label}
                className={classes.productNavLink}
                targetLink={product.targetLink}
                anchorText={product.label}
              />
            ))}
          </div>
          <Tab
            className={classes.navLink}
            targetLink="/about"
            anchorText="About"
          />
          <Tab
            className={classes.navLink}
            targetLink="http://blog.electedtechnologies.com/"
            anchorText="Blog"
          />
          <Tab
            className={classes.navLink}
            targetLink="/contact"
            anchorText="Contact"
          />
        </Col>
      </div>
    </div>
  </div>
);

TopBar.propTypes = {
  classes: PropTypes.object
};

export default injectSheet(styles)(TopBar);



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.jsx